import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Router from "./route/Router";

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
